
<ion-content>
  <div class="page-min-height">
  <ion-card class="card-shadow-7 single-col-wider" style="margin-top: 3em;">
  <form  [formGroup]="resetPasswordForm" *ngIf="loaded">
<ion-grid>
  <ion-row>
    <ion-col
    >
      <h2 class="subheader-regular" style="text-align: center;">{{
        ('keys.data.users_login.reset_password'
          | translate : {Default:'Reset Password'}) || 'Reset Password'
      }}</h2>

       
          </ion-col>
    </ion-row>
  <ion-row>
    <ion-col>
      <ion-card class="card-shadow-3">
      <ion-item>
        <ion-label position="stacked">{{ ('keys.data.users_login.email' | translate :
                            {Default:'Email'}) || 'Email' }}</ion-label>
        <ion-input
          type="email"
          
          name="email"
          formControlName="email"
        ></ion-input>
        <ng-container *ngIf="errors['email']">
          <ion-note
            color="danger" style="font-weight: bold;"
            *ngFor="
              let error of errors['email']
            "
            >{{ error }}
            <br />
          </ion-note>
        </ng-container>
      </ion-item>
    </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-card class="card-shadow-3">
      <ion-item>
        <ion-label position="stacked">{{
          ('keys.data.auth.password' | translate : {Default:'Password'}) ||
  'Password'
        }}</ion-label>
        <ion-input
          type="password"
         
          name="password"
          formControlName="password"
        ></ion-input>
        <ng-container *ngIf="errors['password']">
          <ion-note
            color="danger" style="font-weight: bold;"
            *ngFor="let error of errors['password']"
            >{{ error }}
            <br />
          </ion-note>
        </ng-container>
      </ion-item>
    </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-card class="card-shadow-3">
      <ion-item>
        <ion-label position="stacked">{{
          ('keys.data.users_login.password_confirm'
            | translate : {Default:'Confirm Password'}) || 'Confirm Password'
        }}</ion-label>
        <ion-input
          type="password"
          
          name="password_confirmation"
          formControlName="password_confirmation"
        ></ion-input>
        <ng-container *ngIf="errors['password_confirmation']">
          <ion-note
            color="danger" style="font-weight: bold;"
            *ngFor="
              let error of errors['password_confirmation']
            "
            >{{ error }}
            <br />
          </ion-note>
        </ng-container>
      </ion-item>
    </ion-card>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col  size="12" >
      <ion-button
      class="ion-text-wrap"
        expand="block"
        color="primary"
        (click)="onSubmit()"
        [disabled]="resetPasswordForm.invalid"
      >
       
        {{
          ('keys.data.users_login.reset_password'
            | translate : {Default:'Reset Password'}) || 'Reset Password'
        }}
      </ion-button>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col>
      <ion-button expand="block"
      routerLink="home"
fill="clear"
>{{ ('keys.data.common.back' |
translate) || 'Back' }}</ion-button>
    </ion-col>
  </ion-row>
</ion-grid>
</form>
</ion-card>
</div>
<ion-footer class="ion-no-border">
  <app-footer></app-footer>
</ion-footer>
</ion-content>
